<template>
  <v-system-bar app color="indigo darken-2" dark height="40" v-if="actingGrupoId && !actingDealerId" data-bar="acting-grupo">
    <v-icon>mdi-shield-crown</v-icon>
    <span class="ml-2">
      Estás gestionando el grupo <strong>{{ grupoName }}</strong> como Super Admin. Tus acciones quedan registradas a tu nombre.
    </span>
    <v-spacer></v-spacer>
    <v-btn text small @click="exitGrupo" :loading="loading">
      <v-icon left small>mdi-arrow-left</v-icon>
      Volver a Super Admin
    </v-btn>
  </v-system-bar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'acting-grupo-bar',

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters(['ACTING_GRUPO_ID', 'ACTING_DEALER_ID', 'CURRENT_USER']),

    actingGrupoId () {
      return this.ACTING_GRUPO_ID
    },

    actingDealerId () {
      return this.ACTING_DEALER_ID
    },

    grupoName () {
      return this.CURRENT_USER && this.CURRENT_USER.acting_grupo ? this.CURRENT_USER.acting_grupo.name : 'el grupo'
    }
  },

  methods: {
    async exitGrupo () {
      this.loading = true
      try {
        await this.$store.dispatch('EXIT_GRUPO')
        // Recarga completa para limpiar el estado del grupo
        window.location.href = '/grupos'
      } catch (error) {
        console.error('Error al volver a Super Admin:', error)
        this.$toast.error('No se pudo volver a Super Admin')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-system-bar {
  font-weight: 500;
}
</style>
